import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PlanEditService } from '../common/services/plan-edit.service';
import { ConfirmationDialogComponent, ConfirmDialog } from '../dialogs/dialog-unsaved-changes/confirmation-dialog.component';
import { environment } from 'src/environments/environment';
import { UserService } from '../common/services/user.service';
import { MemberProfile } from '../common/models/profile';
import * as moment from 'moment';
import { PracticeAreas } from '../common/models/practiceAreas';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
    standalone: false
})
export class ProfileComponent implements OnInit {
  constructor(private userService: UserService, private dialog: MatDialog, private planEditService: PlanEditService) {}

  profile: MemberProfile;
  practiceAreas: PracticeAreas;
  cdate: number;

  ngOnInit(): void {
    this.userService.profile().subscribe({
      next: (profile) =>
      {
        this.profile = profile;
        this.cdate = moment(this.profile.member_call.call_dt).year();
      }
    });

    this.userService.practiceAreas().subscribe({
      next: (pa) => this.practiceAreas = pa
    })

  }

  return() {
    const returnConfirm = new ConfirmDialog();
    returnConfirm.title = "Return to Lawyer Portal";
    returnConfirm.message = "Are you sure you want to exit and return to Alberta Lawyer Portal?"
    returnConfirm.okButtonTitle = "Return to Alberta Lawyer Portal";
    returnConfirm.cancelButtonTitle = "Cancel";
    const returnDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '425px',
      height: '430px',
      panelClass: 'pending-changes',
      data: returnConfirm,
      ariaLabelledBy: 'confirm-desc',
      disableClose: true
    });
    returnDialogRef.afterClosed().subscribe((result) => {
      if(result === 'ok') {
        this.planEditService.clear();
        window.location.href = environment.PortalURL;
      }
    });
  }
}
